export default __webpack_public_path__ + "static/media/logo.eb5433eb.svg";